import React, { FC, useContext, useEffect } from 'react';
import meuConsumptionContext from '../../../../../contexts/MeuConsumptionContext';
import { billingRoutes } from '../../../../../routes/BillingRoutes';
import MeuConsumptionDailyUsage from '../../../MeuConsumption/components/MeuConsumptionDailyUsage';
import { MeuConsumptionContainer } from '../../styles';

const DailyUsageComponent: FC = () => {
  const { content, dateToSearch, tenant, setHeaderContent } = useContext(meuConsumptionContext);
  useEffect(() => {
    setHeaderContent({
      redirect: billingRoutes.meuConsumption,
      text: content.formatString(content.header, tenant.info.name),
    });

    return () => setHeaderContent({ redirect: '/' });
  }, [dateToSearch]);

  return (
    <MeuConsumptionContainer>
      <MeuConsumptionDailyUsage isDetailedView />
    </MeuConsumptionContainer>
  );
};

export default DailyUsageComponent;
